import 'anonymous.scss';
import 'print.scss';

import $ from 'jquery';

import 'what-input/src/scripts/what-input';

import { Foundation } from 'libs/foundation';
import Toggler from 'libs/foundation.toggle';
import { Dropdown } from 'foundation-sites/js/foundation.dropdown';
import { Equalizer } from 'foundation-sites/js/foundation.equalizer';

import lazyExports from 'common-lazy-modules';
import App from 'libs/app';

// these are needed on every page
import 'modules/tud.carousel';
import 'modules/tud.combobox';
import 'modules/tud.flyout.starter';
import 'modules/tud.navigation';
import 'modules/tud.pace';
import 'modules/tud.search';
import 'modules/tud.sliderVertical';
import 'modules/tud.togglerGroup';

// these are too small for lazy loading
import 'modules/tud.maxInputLength';
import 'modules/tud.mobileHelper';
import 'modules/tud.multicheck';
import 'modules/tud.scrollAnimation';
import 'modules/tud.toggleCheckboxGroup';

import 'modules/misc/tud.copyrightLink';
import 'modules/misc/tud.jsLinks';
import 'modules/misc/tud.revealA11y';
import 'modules/misc/tud.styledFileUpload';
import 'modules/misc/tud.tableDoubleScroll';
import 'modules/misc/tud.uploadButtonFix';

// init Foundation
Foundation.plugin(Toggler, 'Toggler');
Foundation.plugin(Dropdown, 'Dropdown');
Foundation.plugin(Equalizer, 'Equalizer');

$(document).foundation();

// define a requirejs module with our exports
const exports = {
    App,
};

// setup requirejs settings
window.requirejs.config({
    // timeout for loading modules in seconds (0 means unlimited timeout)
    waitSeconds: 7,
});

window.define('tud.theme.webcms2-common', () => ({ ...exports, ...lazyExports }));
